import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";

import HelpIcon from "src/components/icons/HelpIcons";

export default function HelperIconButton(props) {
  const txt = props.txt ? props.txt : "info";
  const height = props.height ? props.height : "15px";
  const fontSize = props.fontSize ? props.fontSize : "0.8em";
  const showIcon = props.showIcon || false;

  return (
    <Button
      onClick={props.onClick}
      aria-label={"Näytä aputeksti/infoteksti " + txt}
      variant="outlined"
      sx={{ height: height, position: "relative" }}>
      <Typography sx={{ fontSize: fontSize }} noWrap>
        {txt}
      </Typography>

      {showIcon && <HelpIcon sx={{ position: "absolute", left: -12, opacity: 0.8 }} />}
    </Button>
  );
}

HelperIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  txt: PropTypes.string,
  height: PropTypes.string,
  fontSize: PropTypes.string,
  showIcon: PropTypes.bool,
};
